export const CHAT_ROW = {
    height: 84,
    avatarSize: 40,
    avatarIconSize: 20,
} as const;

export const CHAT_UNREAD_BADGE_MAX = 99;
